import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';

@Component({
  selector: 'app-call-details-scorecard-tab',
  templateUrl: './call-details-scorecard-tab.component.html',
  styleUrls: ['./call-details-scorecard-tab.component.scss'],
  providers: [],
})
export class CallDetailsScorecardTabComponent implements OnInit {
  @Input() scorecard: any;
  @Input() print: boolean = false;

  @Output() navigateToAI = new EventEmitter<{ sectionTitle: string, criterion: string }>();

  scorecardTopOne: any[] = [];
  scorecardDetails: any[][] = [];

  ngOnInit(): void {
    this.initScorecardTopOne(this.scorecard);
    this.initScorecardDetails(this.scorecard);
  }

  private initScorecardDetails(scorecard: any) {
    this.scorecardDetails.push([
      scorecard.criteria.find((i: any) => i.sectionTitle.trim() === 'Opener/Intro'),
      scorecard.criteria.find((i: any) => i.sectionTitle.trim() === 'Qualifying'),
    ]);
    this.scorecardDetails.push([
      scorecard.criteria.find((i: any) => i.sectionTitle.trim() === 'Gap Creation'),
      scorecard.criteria.find((i: any) => i.sectionTitle.trim() === 'Veeam Messaging'),
    ]);
    this.scorecardDetails.push([
      scorecard.criteria.find((i: any) => i.sectionTitle.trim() === 'Objection Handling'),
      scorecard.criteria.find((i: any) => i.sectionTitle.trim() === 'End of Call'),
    ]);
  }

  private initScorecardTopOne(scorecard: any) {
    let i = {
      title: 'Talk/Listen Ratio',
      value: Math.round(scorecard.talkListenRatio * 100).toString(10) + '%',
      color: 'green',
      markMessage: 'Good',
    };
    if (scorecard.talkListenRatio < 0.4) {
      i.markMessage = 'Below average';
      i.color = 'red';
    }
    if (scorecard.talkListenRatio > 0.8) {
      i.markMessage = 'Above average';
      i.color = 'red';
    }
    this.scorecardTopOne.push(i);

    //=============

    i = {
      title: 'Filler Words',
      value: scorecard.fillerWords.toString(10) + ' wpm',
      color: 'green',
      markMessage: 'Good',
    };
    if (scorecard.fillerWords < 0.6) {
      i.markMessage = 'Below average';
      i.color = 'red';
    }
    if (scorecard.fillerWords > 3) {
      i.markMessage = 'Above average';
      i.color = 'red';
    }
    this.scorecardTopOne.push(i);

    //=============

    i = {
      title: 'Talk Speed',
      value: scorecard.talkSpeed.toString(10) + ' wpm',
      color: 'green',
      markMessage: 'Good',
    };
    if (scorecard.talkSpeed < 110) {
      i.markMessage = 'Below average';
      i.color = 'red';
    }
    if (scorecard.talkSpeed > 160) {
      i.markMessage = 'Above average';
      i.color = 'red';
    }
    this.scorecardTopOne.push(i);

    //=============

    i = {
      title: 'Longest Monologue',
      value: this.secToMin(scorecard.longestMonologue),
      color: 'green',
      markMessage: 'Good',
    };
    if (scorecard.longestMonologue < 60) {
      i.markMessage = 'Below average';
      i.color = 'red';
    }
    if (scorecard.longestMonologue > 150) {
      i.markMessage = 'Above average';
      i.color = 'red';
    }
    this.scorecardTopOne.push(i);
  }

  secToMin(sec: number) {
    const minutes = Math.floor(sec / 60);
    const seconds = Math.floor(sec % 60);

    return `${minutes}:${String(seconds).padStart(2, '0')}`;
  }

  onEvalRowClick(data: { sectionTitle: string, criterion: string }) {
    this.navigateToAI.emit(data);
  }
}
